<button [id]="buttonId" [class]="'pb-container pb-status-' + buttonStatus + ' pb-container-' + size"
  matRipple [matRippleAnimation]="{ enterDuration: 400 }" (click)="emitClick()"
  [ngClass]="{ 'pb-status-loading': loading }">
  <div *ngIf="!loading" class="kenjo-font-size-16px">{{ title }}</div>
  <div *ngIf="loading" class="kenjo-font-size-16px">
    <kenjo-loading-spinner></kenjo-loading-spinner>
  </div>
</button>
